/**
 * Parse FastAPI 409 detail for duplicate repo URL gates.
 * @returns {{ code: string, message: string, garageCopyUrl?: string, acknowledgeRequired?: boolean } | null}
 */
export function parseRepoUrlGateDetail(error) {
  const status = error?.response?.status;
  if (status !== 409) return null;
  const detail = error?.response?.data?.detail;
  if (!detail || typeof detail !== 'object') return null;
  const code = detail.code;
  if (code !== 'origin_deprecated' && code !== 'existing_garage_copy') return null;
  return {
    code,
    message: detail.message || '',
    garageCopyUrl: detail.garageCopyUrl || '',
    acknowledgeRequired: Boolean(detail.acknowledgeRequired),
  };
}

export function formatApiErrorDetail(error, fallback = 'Something went wrong') {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (detail && typeof detail === 'object' && detail.message) return detail.message;
  return error?.message || fallback;
}
